import axios from 'axios'
import LYCom from "../../static/js/LYCom"
import router from '../router'
import {
    MessageBox,
    Message
} from 'element-ui'

const service = axios.create({

    baseURL: LYCom.CallBizCfg.NewSvrRoot,
    timeout: LYCom.CallBizCfg.Timeout
})
service.interceptors.request.use(

    config => {
        // 判断访问地址是否为任务模块地址
        
        if (config.url.indexOf('taskSvrRoot/') != -1) {
            config.baseURL = LYCom.CallBizCfg.taskSvrRoot;
            config.url = config.url.replace('taskSvrRoot/', '')
        } 
        
        else if (config.url.indexOf('saveAnswerRoot/') != -1) {
            config.baseURL = LYCom.CallBizCfg.saveAnswerRoot;
            config.url = config.url.replace('saveAnswerRoot/', '')
        }
          
        else if (config.url.indexOf('psychSysSvr/') != -1) {
            config.baseURL = LYCom.CallBizCfg.psychSysSvr;
            config.url = config.url.replace('psychSysSvr/', '')
        }
        
         


        let token = window.sessionStorage.getItem("LyToken");
        if (token) {
            config.headers['Authorization'] = token;
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)
service.interceptors.response.use(
    response => {
        const res = response.data

        if (res.code && res.code != 200) {
            if (res.msg == 'token不能为空' || res.msg == "token过期") {
                router.replace("/login"); // token过期返回登录页
            }
            return Promise.reject(res)
        } else {
            return res.data ? res.data : res
        }
    },
    error => {
        return Promise.reject(error)
        if (error.response.status === 401) { // token失效 ,重新获取token
            let refreshToken = window.sessionStorage.getItem("refreshToken");
            if (refreshToken) //刷新令牌存在 且未进行过期
            {

                MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
                    confirmButtonText: '重新登录',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // 确认的回调
                    console.log(service)
                    axios.get(LYCom.CallBizCfg.SvrRoot + 'api/RefreshToken', {
                        params: {
                            refreshToken: refreshToken,
                        }
                    }).then(res => {
                        if (res.data.StatusCode == 200) {
                            window.sessionStorage.setItem("token", res.data.Data.AccessToken);
                            //window.sessionStorage.setItem("userInfo", JSON.stringify(res.data.Data));暂时不考虑更新个人信息
                            location.reload()
                        } else {
                            Message({
                                message: '刷新令牌失效',
                                type: 'error',
                                duration: 1000
                            })
                            window.sessionStorage.removeItem("refreshToken");
                            //刷新令牌失效
                            window.location.href = '/login';
                        }
                    })
                }, action => {
                    // 取消的回调
                    window.location.href = '/login';
                });
            }
            return Promise.reject(error)
            // else if (error.response.status === 500) { // 服务器断开
            //        alert("服务器断开，请稍后重试。");
            //    } else if (error.response.status === 403) { //无auth授权，后台不允许访问
            //        alert("不允许访问,请联系网站");
            //    }
        }
    }
)

export default service



// WEBPACK FOOTER //
// ./src/network/request.js